$(function(){
    $(".slider_slick_container").each(function(i){
	$(this).find(".slider_slick").addClass("slider_slick" + i);
	$(this).find(".arrow_box").addClass("arrow_box" + i);
      $(this).find(".now_count").addClass("now_count" + i);
      $(this).find(".all_count").addClass("all_count" + i);



      
$(this).find(".slider_slick")
        .slick({
       infinite: false,
          speed:500,
       slidesToShow: 4,
      touchThreshold:1000,
 responsive: [
            {
            breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
dots: true,
    });
      
     
});   
}); 